<template>
  <v-list class="py-0">
    <v-item-group
      :value="value"
      :mandatory="forceSelectedItem"
      @change="onChange"
    >
      <reference-log-item
        v-for="item in items"
        :key="item.reference.id"
        :item="item"
        :selected="value === item.reference.id"
        @click="$emit('select-reference', item.reference)"
      />
    </v-item-group>
  </v-list>
</template>

<script>
import ReferenceLogItem from './ReferenceLogItem';

export default {
  name: 'ReferenceLog',
  components: { ReferenceLogItem },
  props: {
    value: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    forceSelectedItem: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasItems() {
      return this.items && this.items.length > 0;
    },
  },
  methods: {
    onChange(referenceId) {
      // Find the selected list item before the change.
      const currentItem = this.items.find(
        (item) => item.reference.id === this.value
      );
      // If it still exists, then allow the change.
      if (currentItem || !this.forceSelectedItem) {
        this.$emit('input', referenceId);
      } else {
        // If not, then make sure the first one is selected.
        // Otherwise v-item-group will select the last item.
        const firstItemId = this.items[0].reference.id;
        this.$emit('input', firstItemId);
      }
    },
  },
};
</script>
